
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { clearInterval } from 'timers';

@Component({
  selector: 'app-reload-dialog',
  templateUrl: './reload.component.html',
  styleUrls: ['./reload.component.css']
})
export class ReloadDialogComponent implements OnInit, OnDestroy {

  title: string;
  message: string;
  interval:NodeJS.Timeout;
  counter = 30;

  constructor(public dialogRef: MatDialogRef<ReloadDialogComponent>) {

    this.interval = setInterval(v=>{

        this.counter--;
      if(  this.counter<0)
      {
        this.counter=0;
      }
        //console.log(this.counter);

        if(this.counter==0)
        {
          clearTimeout(this.interval);
         this.reloadAction();
        }


    }, 1000)

  }

  ngOnInit() {
  }

  reloadAction()
  {
    window.location.href="/";
    console.log("siteReloadType4");
  // this.dialogRef.close(false);
  }

  onConfirm(): void {

  }

  onDismiss(): void {

    this.dialogRef.close(false);
  }

  ngOnDestroy(): void {
    clearTimeout(this.interval);
  }

}
